import React from 'react';
import { useParams } from 'react-router-dom';
import { summaryVFButtonSelectorFieldData } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import 'AppSrc/core/style/components/form/form-base-components/summary-components/summary-v-f-button-selector.css';
import { useSelector } from 'react-redux';
// import {
//   // getIsOlaCrq,
//   getIsInternationalCrq,
// } from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';

const SummaryVFButtonSelector = React.memo(({
  fieldData,
  // formData,
}) => {
  const {
    crqId,
  } = useParams();
  const formData = useSelector((state) => state.editForm.formDataById[crqId]);
  let {
    displayValues,
  } = fieldData;

  // const isIcmCrqs = getIsInternationalCrq(formData);
  const changeDetails = 'CHANGE_DETAILS';
  const oloFlagNetwork = formData ? formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value : null;
  const isRelevantOloService = (oloFlagNetwork === 'Network: Other Licensed Operator (OLO)' || oloFlagNetwork === 'Network: International Other Licensed Operator (OLO)') ? true : false;
  if (fieldData.fieldTitle === 'Select network' && displayValues[0].value === 'fixed' && isRelevantOloService) {
    const displayValuesForOlo = displayValues.map((obj) => ({ ...obj, text: 'OLO Works' }));
    displayValues = displayValuesForOlo;
  }
  if (fieldData.fieldTitle === 'Will this change involve International Service?' && displayValues[0].value === '-' && isRelevantOloService) {
    const displayValuesForOloIcm = displayValues.map((obj) => ({ ...obj, text: 'No' }));
    displayValues = displayValuesForOloIcm;
  }
  if (fieldData.fieldTitle === 'Select network' && displayValues[0].value === '-' && fieldData.value[0] === 'fixedInternational') {
    const displayValuesForInternational = displayValues.map((obj) => ({ ...obj, text: 'International' }));
    displayValues = displayValuesForInternational;
  }
  return (
    <div className="summary-field-v-f-button-selector">
      <p className="field-title">
        {fieldData.fieldTitle}
      </p>
      <ul className="field-values">
        {
          displayValues.map((item) => (
            <li
              key={item.value}
            >
              <p>
                {item.text}
              </p>
            </li>
          ))
        }
      </ul>
    </div>
  );
});

SummaryVFButtonSelector.propTypes = {
  fieldData: summaryVFButtonSelectorFieldData,
  // formData: formDataShape,
};

export { SummaryVFButtonSelector };

